import * as React from 'react';
import { useHistory } from 'react-router-dom';
import Searchbox from '../Controls/SearchBox';
import { withTranslation } from 'react-i18next';
import * as i18next from 'i18next';
import Spinner from '../Controls/Spinner';
import Site from './Site';
import driverinfosecurity from '../../utils/DriverInfoSecurity';
import { useSearchSites } from '../../hooks/useSiteInfo';
import { filter } from '../../constants/filter';

interface IProps {
    onSearchActive?: () => void;
    onSearchCleared?: () => void;
}

function SearchSites({ onSearchActive, onSearchCleared }: IProps) {
    const [inputValue, setInputValue] = React.useState('');
    const [committedQuery, setCommittedQuery] = React.useState<string | null>(null);
    const [, setActiveFilterText] = React.useState(i18next.t('site.all'));
    const [activeFilterValue, setActiveFilterValue] = React.useState('All');

    const history = useHistory();
    const isAdmin = driverinfosecurity.isAdmin();

    const { data: siteInfos = [], isFetching, isSuccess } = useSearchSites(committedQuery, isAdmin ? activeFilterValue : 'Published');

    React.useEffect(() => {
        if (committedQuery !== null) {
            onSearchActive?.();
        } else {
            onSearchCleared?.();
        }
    }, [committedQuery]);

    // Auto-redirect when exactly one result
    React.useEffect(() => {
        if (isSuccess && siteInfos.length === 1) {
            setCommittedQuery(null);
            setInputValue('');
            history.push('/s/' + siteInfos[0].uniqueSiteId);
        }
    }, [isSuccess, siteInfos]);

    function handleSearchQueryChange(e: React.ChangeEvent<HTMLInputElement>) {
        const { value } = e.target;
        setInputValue(value);
        if (!value) {
            setCommittedQuery('');
        }
    }

    function handleChangeFilter(e: { target: { value: string } }) {
        setActiveFilterValue(e.target.value);
        const found = filter.find(f => f.filterKey === e.target.value);
        setActiveFilterText(found ? i18next.t(found.languageKey) : e.target.value);
    }

    function searchSites(e: React.FormEvent) {
        e.preventDefault();
        setCommittedQuery(inputValue);
    }

    function clearSearchQuery() {
        setInputValue('');
        setCommittedQuery(null);
    }

    return (
        <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <img src={new URL('../../img/searchtitleicon.png', import.meta.url).href} alt="" />
                <h1 style={{ margin: 0, fontSize: 22, fontWeight: 600 }}>{i18next.t('headers.searchsite')}</h1>
            </div>
            {isAdmin
                ? <Searchbox searchSite={searchSites} handleChange={handleSearchQueryChange} searchQuery={inputValue} activeFilterValue={activeFilterValue} handleChangeFilter={handleChangeFilter} />
                : <Searchbox searchSite={searchSites} handleChange={handleSearchQueryChange} searchQuery={inputValue} />
            }
            <div className="siteList" style={{ marginTop: 12 }}>
                {isFetching ? <Spinner /> :
                    siteInfos.length <= 0 && committedQuery && isSuccess
                        ? <div>{i18next.t('site.nosite')}</div>
                        : siteInfos.map(siteInfo => <Site key={siteInfo.uniqueSiteId + siteInfo.siteName} site={siteInfo} searchQuery={committedQuery ?? ''} clearSearchQuery={clearSearchQuery} />)
                }
            </div>
        </div>
    );
}

export default withTranslation('translations')(SearchSites);
